import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { BillingInterval, PlanType } from "sdk/types";
import {
  monthlyPricesByIntervalAndPlan,
  pricesByBillingIntervalAndPlan,
} from "~/constants";
import { Trans } from "~/utils/i18next";

interface Props {
  interval: BillingInterval;
  plan: PlanType;
}

export const BillingIntervalRadioLabel: FC<Props> = ({ interval, plan }) => {
  const { t } = useTranslation();
  const base = `planPayment.billingInterval.${interval}` as const;
  const descriptionKey = `${base}.description` as const;
  const pillKey = `${base}.pill` as const;
  const pill = t(pillKey);
  const price = pricesByBillingIntervalAndPlan[interval][plan];
  const monthlyPrice =
    monthlyPricesByIntervalAndPlan[interval][plan]?.toFixed(2) ?? "";
  const priceFmt =
    interval == "1-month" ? (
      <Text fontWeight="bold">
        <Trans i18nKey="planPayment.price.withTermShort" values={{ price }} />
      </Text>
    ) : (
      <Text>
        <Trans
          i18nKey="planPayment.price.withMonthlyCalculation"
          values={{ price, monthlyPrice }}
        />
      </Text>
    );

  return (
    <Flex
      direction={{ base: "column", md: "row" }}
      justify="space-between"
      w="full"
    >
      <Flex wrap="wrap">
        <Text mr={2}>{t(descriptionKey)}</Text>
        {pill && (
          <Flex
            align="center"
            bg="th.blueGreen1"
            display={{ base: "none", md: "flex" }}
            justify="center"
            px={2}
            py={1}
            rounded="full"
          >
            <Text variant="th-t4">{t(pillKey)}</Text>
          </Flex>
        )}
      </Flex>
      {priceFmt}
      {pill && (
        <Flex
          align="center"
          bg="th.blueGreen1"
          display={{ base: "flex-end", md: "none" }}
          justify="center"
          mt={1}
          px={2}
          py={1}
          rounded="full"
          w="fit-content"
        >
          <Text variant="th-t4">{t(pillKey)}</Text>
        </Flex>
      )}
    </Flex>
  );
};
